import React, {useMemo, useState} from "react";
import {Autocomplete, MenuItem, TextField} from "@mui/material";
import {UserAvatar} from "@atttomyx/react-components";
import {arrays, forms, objects, users} from "@atttomyx/shared-utils";

const getOptionLabel = (option) => option && option.id ? users.getFullName(option) : "";

const NodeField = (props) => {
    const { required, nodes, excludedIds, value, onChange } = props;
    const [datum, setDatum] = useState(getOptionLabel(value));

    const idToNode = useMemo(() => {
        return arrays.getIdToEntity(nodes);
    }, [nodes]);

    return <div className="node-field">
        <Autocomplete
            options={nodes}
            value={objects.defaultIfNullOrUndefined(idToNode[datum], {})}
            inputValue={forms.sanitizeValue(datum)}
            getOptionDisabled={option => arrays.contains(excludedIds, option.id)}
            isOptionEqualToValue={(option, value) => option && value && option.id === value.id}
            getOptionLabel={getOptionLabel}
            renderOption={(props, option) =>
                <MenuItem {...props}>
                    <UserAvatar user={option} mode="right" size="small"/>
                </MenuItem>}
            renderInput={params =>
                <TextField
                    required={required}
                    label="Member"
                    {...params}
                />}
            onInputChange={(event, value, reason) => {
                if (reason !== "reset") {
                    setDatum(value);
                    onChange(null);
                }
            }}
            onChange={(event, value) => {
                onChange(value ? value.id : null);
                setDatum(getOptionLabel(value));
            }}
        />
    </div>
};

export default NodeField;
